export default __webpack_public_path__ + "static/media/5.36ba8314.jpg";